package com.neurobs.react.semanticui

import com.neurobs.react.{ReactUtil, StyleUtil}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html._

import scala.scalajs.js

object UiButtonFactory {

  private def TemplateButton(handleClick: () => Unit, children: ReactElement*)(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("button"),
      onClick := handleClick,
      style := uiElementModifiers.createStyle
    )(
      children:_*
    )
  }

  def Button(display: ReactElement, handleClick: () => Unit)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateButton(handleClick, display)(uiElementModifiers)
  }

  def LoadingButton(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateButton(handleClick = {() => {}}, "Loading")(uiElementModifiers.addModifier("loading"))
  }

  def IconButton(handleClick: () => Unit, iconName: String, iconModifiers: String = "", iconClassName: String = "", iconStyle: Seq[(String, js.Any)] = Seq())(implicit uiElementModifiers: UiElementModifiers) = {
    val icon = UiIconFactory.Icon(iconName)(iconModifiers, iconClassName, iconStyle)
    val buttonModifiers = "icon " + uiElementModifiers.elementModifiers
    TemplateButton(handleClick, icon)(buttonModifiers, uiElementModifiers.classString, uiElementModifiers.styleAttributes)
  }

  def LabeledIconButton(display: String, handleClick: () => Unit, iconName: String, iconPosition: String = "left",  iconModifiers: String = "", iconClassName: String = "", iconStyle: Seq[(String, js.Any)] = Seq())(implicit uiElementModifiers: UiElementModifiers) = {
    val icon = UiIconFactory.Icon(iconName)(iconModifiers, iconClassName, iconStyle)
    val buttonModifiers = (if (iconPosition == "right") "right" else "") + " labeled icon " + uiElementModifiers.elementModifiers
    TemplateButton(handleClick, icon, display)(buttonModifiers, uiElementModifiers.classString, uiElementModifiers.styleAttributes)
  }

  def DisabledButton(display: String)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateButton(handleClick = () => {}, children = display)(uiElementModifiers.addModifier("disabled"))
  }
}